<template>
  <div class="header-filter">
    <el-form class="flex" :model="formData" ref="form" label-width="80px">
      <el-form-item
        v-for="item in formItems"
        :key="item.prop"
        :label="item.label"
        :label-width="item.labelWidth ? item.labelWidth : ''"
      >
        <component
          :is="item.is"
          v-model="formData[item.prop]"
          clearable
          format="yyyy-MM-dd"
          :value-format="item.foremd ? item.foremd : 'yyyy-MM-dd HH:mm:ss'"
          :type="item.type ? item.type : ''"
          :filterable="item.reserve ? true : false"
          :remote="item.reserve ? true : false"
          :reserve-keyword="item.reserve ? true : false"
          :placeholder="item.placeholder"
          :default-time="item['default-time'] ? item['default-time'] : null"
          :remote-method="val => remoteMethodgroup(item, val)"
          @change="changeitem('chang', item)"
          @input="item.is === 'el-input' ? changeitem('input', item) : ''"
          :style="{ width: item.width ? item.width : '' }"
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </component>
      </el-form-item>
    </el-form>
    <div class="but-solt">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyFromFilter",
  props: {
    formItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {}
    };
  },
  created() {
    for (const key in this.formItems) {
      if (this.formItems[key].value) {
        this.formData[this.formItems[key].prop] = this.formItems[key].value;
        this.$emit("change", this.formData);
      }
    }
  },
  methods: {
    remoteMethodgroup(item, val) {
      this.$emit("remote", { item, val });
    },
    changeitem(val, item) {
      console.log(val, item);
      if (val === "chang" && item.is !== "el-input") {
        this.$emit("change", this.formData);
      } else if (val === "input") {
        this.$emit("change", this.formData);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.header-filter {
  width: 100%;
  justify-content: space-between;
  padding-right: 12px;
}
.but-solt {
}
</style>



// WEBPACK FOOTER //
// src/components/MyFromFilter.vue